<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px #777 solid;
  color: black;
  background-color: rgba(255,255,255,0.8);
}

</style>

{#each links as item, index}
<LinkInput icon="{item.icon}" bind:link="{item.link}" index="{index}" on:delete="{deleteLink}"></LinkInput>
{/each}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import LinkInput from "./LinkInput.svelte";

export let links = [];

function deleteLink(e) {
  links.splice(e.detail.index, 1);
  links = links;
}


</script>